import { useCallback, useRef } from './core.js';
import { useEventListener } from './useEventListener.js';
export function useOutsideClick(onClick) {
    const targetRef = useRef(null);
    const handleClickOutside = useCallback((event) => {
        if (targetRef && targetRef.current && event.target instanceof Node && !targetRef.current.contains(event.target)) {
            onClick();
        }
    }, [onClick]);
    useEventListener(globalThis.document, 'click', handleClickOutside);
    return targetRef;
}
